import { getLocation } from '@/redux/location/selectors';
import { useSelector } from 'react-redux';
import { useSummary } from '@/hooks/useCompany';
import { useValidateCompanyShareToken } from './useValidateCompanyShareToken';
import { useCreateCompanyShareToken } from './useCreateCompanyShareToken';

export const useCompanyShareLink = () => {
  const location = useSelector(getLocation);
  const token = location?.query?.token ?? '';
  const summary = useSummary();
  const { isValidShareToken, status, logo } = useValidateCompanyShareToken(
    token,
    summary.status === 'success' ? summary.companyId : undefined
  );
  const { mutate } = useCreateCompanyShareToken();
  return {
    isSharedCompany: isValidShareToken,
    shareCompanyStatus: status,
    logo,
    createCompanyShareToken: mutate,
  };
};
